export const PaymentMethods = [
    {'name' : 'Credit/Debit Card', 'value' : 'card'},
    {'name' : 'Check', 'value' : 'check'},
    {'name' : 'Cash', 'value' : 'cash'},
    {'name' : 'Other', 'value' : 'other'}
];